import { InputNumber, message, Popconfirm, Space, Typography } from "antd"
import React, { useState } from "react"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { EuroCircleOutlined } from "@ant-design/icons"

const { Link, Text } = Typography

export default function HandleOrderCredit({ client }) {
  // Initialize local state with the current creditLimit (default to 0 if not set)
  const [creditLimit, setCreditLimit] = useState(client.creditLimit || 0)

  const creditUsedUp = client.creditUsed ? client.creditUsed : 0

  // Function to update credit limit in Firestore on confirmation
  const confirm = async () => {
    try {
      const orderRef = doc(db, "clients", client.id)
      await updateDoc(orderRef, {
        creditLimit,
        creditLeft: creditLimit - creditUsedUp,
      })
      message.success("Credit limit updated successfully")
    } catch (error) {
      console.error("Error updating credit limit:", error)
      message.error("Failed to update credit limit")
    }
  }

  const cancel = () => {
    message.error("Update cancelled")
  }

  // Description renders the InputNumber component with an onChange handler
  const description = () => {
    return (
      <>
        <Text>
          Please select the new order credit limit (Eur):{" "}
          <InputNumber
            value={creditLimit}
            onChange={(value) => setCreditLimit(value)}
            size="small"
          />
        </Text>
      </>
    )
  }

  return (
    <div>
      <Popconfirm
        title="Update credit limit"
        description={description()}
        onConfirm={confirm}
        onCancel={cancel}
        okText="Accept"
        cancelText="Cancel">
        <Space>
          <Link>{client && client.creditLimit}</Link>
          <EuroCircleOutlined style={{ color: "green" }} />
        </Space>
      </Popconfirm>
    </div>
  )
}
